"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.ModuleCoverForm = void 0;
var moduleCoverForm_1 = require("./moduleCoverForm");
Object.defineProperty(exports, "ModuleCoverForm", { enumerable: true, get: function () { return __importDefault(moduleCoverForm_1).default; } });
